import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/conta-receber';

const getParams = (params) => {
  let newParams;
  if (params?.filtroAvancado) {
    newParams = { ...params, ...params.filtroAvancado };

    delete newParams.filtroAvancado;
  } else {
    newParams = params;
  }

  newParams = {
    ...newParams,
    mesCompetencia: newParams?.mesCompetencia?.format('YYYY-MM-DD'),
    dataVencimento: newParams?.dataVencimento?.format('YYYY-MM-DD'),
    dataRecebimento: newParams?.dataRecebimento?.format('YYYY-MM-DD'),
    dataLiquidacao: newParams?.dataLiquidacao?.format('YYYY-MM-DD'),
    dataEmissao: newParams?.dataEmissao?.format('YYYY-MM-DD'),
    dataVencimentoRecebimento: newParams?.dataVencimentoRecebimento?.format('YYYY-MM-DD'),
    categoriaId: newParams?.categoriaId || newParams?.categoria?.id,
  };

  return newParams;
};

export default {
  cadastrar: async (contaReceber) => {
    return financeiroApi.post(`${PATH}`, contaReceber);
  },
  buscarPorId: async (id) => {
    return financeiroApi.get(`${PATH}/${id}`);
  },
  buscarHistorico: async (id) => {
    return financeiroApi.get(`${PATH}/${encodeURIComponent(id)}/historico`);
  },
  buscar: async (params) => financeiroApi.get(`${PATH}`, { params: getParams(params) }),
  atualizar: async (id, contaReceber) => {
    return financeiroApi.put(`${PATH}/${id}`, contaReceber);
  },
  somatorio: (filtro) => {
    return financeiroApi.post(`${PATH}/somatorio`, getParams(filtro));
  },
  baixar: (data) => {
    return financeiroApi.patch(`${PATH}/baixa`, data);
  },
  cancelarBaixas: (data) => {
    return financeiroApi.delete(`${PATH}/baixa`, { data: getParams(data) });
  },
  excluir: (filtro) => {
    return financeiroApi.delete(`${PATH}`, { data: getParams(filtro) });
  },
  enviarCobrancasEmail: (request) => {
    return financeiroApi.post(`${PATH}/enviar-cobrancas-email`, request);
  },
  enviarNotaFiscal: async (ids) => {
    return financeiroApi.post(`${PATH}/enviar-nota-fiscal`, ids);
  },
  buscarAcrescimos: async (params) => financeiroApi.get(`${PATH}/acrescimos`, { params }),
  buscarVendaPorContaReceberId: async (id) => {
    return financeiroApi.get(`${PATH}/buscarVenda/${id}`);
  },
  buscarContratoPorContaReceberId: async (id) => {
    return financeiroApi.get(`${PATH}/buscarContrato/${id}`);
  },
  obterModelo: () => {
    return financeiroApi.get(`${PATH}/modelo`);
  },
  importar: async (arquivo, idNotificacao) => {
    try {
      return financeiroApi.post(`${PATH}/importar?idNotificacao=${idNotificacao}`, arquivo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          type: 'formData',
        },
      });
    } catch (error) {
      throw error;
    }
  },
};
